import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es7.promise.finally.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TeDialog from 'src/components/Dialogs/TEDialog';
import { dialog } from 'src/boot/mixins.js';
import ApprovalRequest from 'src/store/models/ApprovalRequest';
export default {
  mixins: [dialog],
  components: {
    TeDialog: TeDialog
  },
  props: {
    approvalRequestId: {
      type: [String, Number],
      required: true
    },
    action: {
      type: String,
      required: true,
      validator: function validator(value) {
        return ['approve', 'reject', 'withdraw'].includes(value);
      }
    }
  },
  data: function data() {
    return {
      notes: ''
    };
  },
  computed: {
    title: function title() {
      switch (this.action) {
        case 'reject':
          return this.$t('components.approvalsDialog.reject_title');

        case 'withdraw':
          return this.$t('components.approvalsDialog.withdraw_title');

        default:
          return this.$t('components.approvalsDialog.title');
      }
    },
    actionLabel: function actionLabel() {
      switch (this.action) {
        case 'reject':
          return this.$t('components.approvals.action.reject');

        case 'withdraw':
          return this.$t('components.approvals.action.withdraw');

        default:
          return this.$t('components.approvals.action.approve');
      }
    }
  },
  methods: {
    approvalRequestUpdateStatus: function approvalRequestUpdateStatus(notes) {
      var _this = this;

      this.$q.loading.show();
      ApprovalRequest.api()[this.action](this.approvalRequestId, {
        event_notes: notes
      }).then(function () {
        _this.$q.notify({
          message: _this.$t('components.approvalsDialog.request_updated'),
          color: 'positive'
        });
      }).finally(function () {
        _this.$q.loading.hide();

        _this.hide();
      });
    }
  }
};